/* unplugin-vue-components disabled */import { render } from "./templateDemoViewHeader.vue?vue&type=template&id=93b82744&scoped=true"
import script from "./templateDemoViewHeader.vue?vue&type=script&lang=js"
export * from "./templateDemoViewHeader.vue?vue&type=script&lang=js"

import "./templateDemoViewHeader.vue?vue&type=style&index=0&id=93b82744&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b82744"]])

export default __exports__